import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, dateTimeFormat, dateTimeFormatIOS } from 'pages/Common';

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}
const CreateAppointmentModel = ({ modal, toggle, isEdit, editData, AppointmentListApi, AssignByData }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [date, setDate] = useState(new Date())
    const [handleByValue, setHandleByValue] = useState({
        label: 'Select user',
        value: 0,
    })
    const [handleByerror, setHandleByError] = useState(false)
    const [userData, setUserData] = useState([])
    const [leadTypeValue, setLeadTypeValue] = useState(0)
    const [leadType, setLeadType] = useState([])
    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };
    const [leaderror, setLeadError] = useState(false)


    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                options.unshift({
                    label: isEdit ? editData?.HandleByName : "Select user",
                    value: isEdit ? editData?.HandleBy : 0,
                }
                );
                setHandleByValue(options[0])
                setUserData(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

        getApi('Lead/type/lookup').then(({ data, status }) => {
            if (status === 200) {
                setLeadType(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    useEffect(() => {
        if (editData?.HandleBy && editData?.AppointmentTime) {
            setHandleByValue({
                label: isEdit ? editData?.HandleByName : '',
                value: isEdit ? editData?.HandleBy : 0,
            })
            setDate(new Date(editData?.AppointmentTime))
        } else {
            validation.setFieldValue("Name", "")
            validation.setFieldValue("ContactNo", "")
            validation.setFieldValue("Address", "")
            validation.setFieldValue("Remark", "")
            // setDate(new Date())
            setHandleByValue({
                label: 'Select user',
                value: 0,
            })
        }

    }, [editData?.HandleBy, isEdit])

    // Appointment Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Name: editData ? editData?.Name : '',
            ContactNo: editData ? editData?.ContactNo : '',
            HandleBy: 0,
            Address: editData ? editData?.Address : '',
            Remark: editData ? editData?.Remark : "",
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("The name is required"),
            ContactNo: Yup.string().required("The contactNo is required"),
            Address: Yup.string().required("The Address is required"),
            Remark: Yup.string().required("The remark is required"),
        }),
        onSubmit: values => {
            if (handleByValue.value == 0 && !isEdit && AssignByData == '') {
                setLeadError(false)
                setHandleByError(true)
                return true
            }

            setformSumitLoading(true)
            if (values) {
                isEdit ?
                    putApi("Appointment/update", {
                        Id: editData.Id,
                        Name: values.Name,
                        ContactNo: values.ContactNo,
                        HandleBy: handleByValue.value || 0,
                        Address: values.Address,
                        AppointmentTime: dateTimeFormatIOS(date),
                        Remark: values.Remark,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (AppointmentListApi != '') {
                                AppointmentListApi()
                            }
                            validation.handleReset()
                        }
                    })
                    :
                    postApi("Appointment/create", {
                        Name: values.Name,
                        ContactNo: values.ContactNo,
                        LeadType: parseInt(leadTypeValue) || 0,
                        HandleBy: AssignByData?.AssignBy ? AssignByData?.AssignBy : handleByValue.value || 0,
                        Address: values.Address,
                        AppointmentTime: dateTimeFormatIOS(date),
                        Remark: values.Remark,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (AppointmentListApi != '') {
                                AppointmentListApi()
                            }
                            validation.handleReset()
                        }
                    })
            }
        },
    })

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "400px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Appointment" : "Create Appointment"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={8}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Name
                                    </Label>
                                    <Input
                                        name="Name"
                                        placeholder="Name"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Name}
                                        invalid={
                                            validation.touched.Name && validation.errors.Name
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Name && validation.errors.Name ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Name}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Contact No.
                                    </Label>
                                    <Input
                                        name="ContactNo"
                                        placeholder="contact no."
                                        type="text"
                                        maxLength={10}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        onKeyPress={handleKeyPress}
                                        value={validation.values.ContactNo}
                                        invalid={
                                            validation.touched.ContactNo && validation.errors.ContactNo
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.ContactNo && validation.errors.ContactNo ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.ContactNo}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>


                        <>
                            < Row >
                                <Col md={AssignByData?.AssignBy ? 12 : 7}>
                                    <FormGroup className="mb-2">
                                        <Label
                                            htmlFor="validationCustom03"
                                            className="required"
                                        >
                                            Appointment Time
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "d-m-Y h:i K",  // h:i K = 12hr time with AM/PM
                                                    time_24hr: false,           // explicitly 12-hour format
                                                    disableMobile: true
                                                }}
                                                value={date}
                                                onChange={(e) => { setDate(e) }}
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                                <>
                                    {AssignByData?.AssignBy ? '' :
                                        <>
                                            <Col md={5}>
                                                <FormGroup className="mb-2">
                                                    <Label
                                                        htmlFor="validationCustom03"
                                                        className="required"
                                                    >
                                                        Handle By
                                                    </Label>
                                                    <Select
                                                        unstyled
                                                        styles={handleByerror ? colourStyles1 : colourStyles}
                                                        value={handleByValue}
                                                        onChange={(e) => {
                                                            setHandleByValue(e)
                                                            setHandleByError(false)
                                                        }}
                                                        options={userData}
                                                        className="select2-selection"
                                                    />
                                                    {handleByerror ? (
                                                        <div className="name-required">
                                                            {"  Handle By is Required"}
                                                        </div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                        </>
                                    }

                                </>
                            </Row>
                        </>
                        <Row>
                            <FormGroup className="mb-2">
                                <Label htmlFor="validationCustom03" className="required">
                                    Address
                                </Label>
                                <Input
                                    name="Address"
                                    placeholder="Enter address here"
                                    type="textarea"
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Address}
                                    invalid={
                                        validation.touched.Address && validation.errors.Address
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.Address && validation.errors.Address ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.Address}
                                    </FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="mb-2">
                                <Label htmlFor="validationCustom03" className="required">
                                    Remark
                                </Label>
                                <Input
                                    name="Remark"
                                    placeholder="Enter remark here"
                                    type="textarea"
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Remark}
                                    invalid={
                                        validation.touched.Remark && validation.errors.Remark
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.Remark && validation.errors.Remark ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.Remark}
                                    </FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Row>

                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                type="reset"
                                color="secondary"
                            >
                                Reset
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal >
    )
}

export default CreateAppointmentModel